<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'ADD INCOTERM' : 'UPDATE INCOTERM'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-incoterms-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Code</small>
                <vs-input v-model="form.code"  name="code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="is_price_included" name="is_price_included" rules="" v-slot="{ errors }">
                <small class="label">Is shipping price included?</small>
                <v-select name="is_price_included" :closeOnSelect="true" v-model="form.is_price_included"
                  :options="[{name: 'Yes', value: true}, {name: 'No', value: false}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                  label="name" :reduce="option => option.value"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-incoterms-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const IncotermRepository = RepositoryFactory.get('incoterm');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        is_price_included: false
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewIncotermsPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchIncotermDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchIncotermDetails() {
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          const {data} = (await IncotermRepository.getIncoterms(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await IncotermRepository.createIncoterms(this.form);
            this.showSuccessMessage('Incoterm added!');
          } else {
            await IncotermRepository.updateIncoterms(this.id, this.form);
            this.showSuccessMessage('Incoterm updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
